import { api } from "../../api";

export const initPage = async (
  state,
  setState,
  id,
  navigate,
  page = "home"
) => {
  const { data } = await api
    .get("assessmentactive/" + id)
    .catch((error) => error.response);

  if (data.payload.length > 0) {
    setState({
      ...state,
      event: data.payload[0],
      open: false,
    });
  } else {
    if (page === "login") {
      navigate("/process");
    } else {
      navigate("/expired");
    }
  }
};
